import { render } from "./SmallIcon.vue?vue&type=template&id=4819d72e&scoped=true"
import script from "./SmallIcon.vue?vue&type=script&lang=js"
export * from "./SmallIcon.vue?vue&type=script&lang=js"

import "./SmallIcon.vue?vue&type=style&index=0&id=4819d72e&scoped=true&lang=css"

import exportComponent from "/Users/permartinson/Documents/GitHub/wpcedit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4819d72e"]])

export default __exports__